import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const liveEventsQueryOptions = (status?: "scheduled" | "live" | "ended" | "cancelled") =>
  queryOptions({
    queryKey: ["live-events", status],
    queryFn: () => rpc("get-live-events", { status }),
  });

export const liveEventByIdQueryOptions = (eventId: string) =>
  queryOptions({
    queryKey: ["live-event", eventId],
    queryFn: () => rpc("get-live-event-by-id", { event_id: eventId }),
  });
